import { QueryParams } from "./lib/query/query.data";
import { MatPaginator } from "@angular/material/paginator";

export type NullPart<T> = T & (null | undefined);

export type MustBeAmbiguouslyNullable<T> = NullPart<T> extends never
  ? never
  : NonNullable<T> extends never
    ? never
    : T;

export function hasValue<T>(
  value: MustBeAmbiguouslyNullable<T>,
): value is NonNullable<MustBeAmbiguouslyNullable<T>> {
  return (value as unknown) !== undefined && (value as unknown) !== null;
}

export function setQueryVarsFromPaginator(
  query: QueryParams,
  paginator: MatPaginator,
): void {
  query.limit = paginator.pageSize;
  query.skip = paginator.pageIndex * paginator.pageSize;
}